import axiosInstance from "./AxiosConfig";

class HelpDeskApi {

    // ---------------- CREATE ----------------
    async CreateHelpDesk(data) {
        try {
            const response = await axiosInstance.post(
                "/helpDesk/create",
                data
            );
            return response.data;
        } catch (error) {
            console.error("CreateHelpDesk Error:", error);
            return null;
        }
    }

    // ---------------- GET ALL ----------------
    async GetAllHelpDesk() {
        try {
            const response = await axiosInstance.get(
                `/helpDesk/get`
            );
            return response.data;
        } catch (error) {
            console.error("GetAllHelpDesk Error:", error);
            return null;
        }
    }

    // ---------------- GET BY ID ----------------
    async GetHelpDeskById(id) {
        try {
            const response = await axiosInstance.get(
                `/helpDesk/get/${id}`
            );
            return response.data;
        } catch (error) {
            console.error("GetHelpDeskById Error:", error);
            return null;
        }
    }

    // ---------------- UPDATE ----------------
    async UpdateHelpDesk(id, data) {
        try {
            const response = await axiosInstance.put(
                `/helpDesk/update/${id}`,
                data
            );
            return response.data;
        } catch (error) {
            console.error("UpdateHelpDesk Error:", error);
            return null;
        }
    }

    // ---------------- DELETE ----------------
    async DeleteHelpDesk(id) {
        try {
            const response = await axiosInstance.delete(
                `/helpDesk/delete/${id}`
            );
            return response.data;
        } catch (error) {
            console.error("DeleteHelpDesk Error:", error);
            return null;
        }
    }
}

export default new HelpDeskApi();